export default "__VITE_ASSET__a1ec3ffc__"